module.exports = __webpack_public_path__ + "assets/img/footer_logo_ru.32ff983d.png";